import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./styles.scss";
import photoOne from "../../assets/photos/UNM_HS-Wellness_Art-Walk-9_WEB.jpg";

import "./styles.scss";

function SectionSeven({ placeholderSrc }) {
  return (
    <div>
      <div className="tw-spacer tw-h-[6rem]"></div>
      <div className="tw-grid  grid-cols-1 lg:tw-grid-cols-[55%_45%] lg:tw-mt-11">
        <div className="tw-order-2 lg:tw-order-1 tw-bg-secondary  tw-flex tw-items-center">
          <div className="tw-grid  grid-cols-1 lg:tw-grid-cols-[10%_90%] tw-h-[100%] bl-">
            <div className="tw-bg-primary"></div>
            <div className="tw-py-8 tw-px-4 lg:tw-pl-[6rem] lg:tw-p-[4rem] tw-bg-secondary">
              <p className="tw-font-bold tw-italic tw-mb-0 tw-border-t-[1px] tw-border-white tw-pt-3 tw-text-2xl tw-w-1/2">
                Art in Engineering
              </p>
              <p>
                Architecture or artistry? This New Mexico sky blue scaffold-like
                structure narrows the space between form and function, playing
                with the intersection of useful form and pure expression. Is it
                sculpture or architecture? A closer look seems to reveal the
                truth, at least behind this work!
              </p>
            </div>
          </div>
        </div>
        <div className="lg:tw-order-2 tw-order-1 -tw-secondary-gradient-to-right">
          <div className="tw-grid tw-grid-cols-1  lg:tw-grid-cols-[90%_10%] tw-leading-[0px]">
            <div className="tw-order-1 lg:tw-order-2"></div>
            <div className="tw-order-2 lg:tw-order-1  tw-relative">
              <LazyLoadImage
                alt="Art in Engineering"
                src={photoOne}
                className="lg:tw-relative tw-top-[-80px]"
                placeholderSrc={placeholderSrc}
              
              />
              <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] tw-block tw-bottom-[-10px] tw-right-[-30px]">
                7
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionSeven;
